<template>
  <div>
    <div v-if="$vuetify.breakpoint.lgAndUp" :class="{'headroom--unpinned': scrolled}" v-on="handleScroll"
         class="header-position">

      <div class="black">
        <div class="mx-11">
          <v-row class="pt-1">
            <v-col class="d-flex align-center" cols="6">
              <div @click="$router.push('/')" style="cursor: pointer;">
                <img v-if="$route.path.indexOf('light-blocks')>0" width="150" src="@/assets/eng_logo.png" alt="icon">
              </div>
            </v-col>
            <v-col :class="[this.$i18n.locale==='pr'?'text-left':'text-right']" cols="6">
              <div class="d-flex justify-end align-center ">
                <form style="display: flex; position: relative" id="demo-2">
                  <input type="search" placeholder="Search">
                  <v-icon style="position: absolute;top: 10px;right: 6px;"
                          :class="[this.$route.name==='lightWeightBlocks'?'hover':'hover2']"
                  >mdi-magnify
                  </v-icon>
                </form>
                <v-btn small class="mx-4" depressed icon>
                  <p class="ma-0">
                    <v-icon :class="this.$route.name==='lightWeightBlocks'?'hover':'hover2'">mdi-account</v-icon>

                  </p>
                </v-btn>
                <v-menu class="header-color" offset-y open-on-hover>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text
                           v-bind="attrs"
                           v-on="on"
                    >
                      <h6 class="white--text">{{ flag[selectedFlag] }}</h6>
                      <!--                      <img width="30" :src="flag[selectedFlag]" :alt="flag[selectedFlag]">-->
                    </v-btn>
                  </template>
                  <div class="header-color d-flex flex-column"
                  >
                    <v-btn
                        v-if="i!==selectedFlag"
                        :class="[
                            i===item.length?languageBorderClass():null
                        ]"
                        :style="{'border-bottom':i ===item.length? '':'1px solid #AFAFAF'}"
                        @click="changeLanguage(i)" class=" menu-item black--text" v-for="(item,i) in flag" :key="i" dark
                        text>
                      {{ item }}
                      <!--                      <img width="30" :src="item" :alt="i">-->
                    </v-btn>
                  </div>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
      <!--    header-->
      <div style="height:80px" class="header-color">
        <div class="mx-6">
          <v-row :class="[this.$i18n.locale=='en'?'flex-direction-row-reverse':'']" no-gutters class="align-center">
            <v-col style="cursor: pointer" class="text-center pt-2" md="3" cols="2">
              <img @click="$router.replace('/sub/light-blocks')" v-if="$route.path.indexOf('light-blocks')>0"
                   height="64" src="@/assets/bloc_logo.svg" alt="icon">
              <img @click="$router.replace('/')" v-else width="280" src="@/assets/eng_logo.png" alt="icon">
            </v-col>
            <v-col class="d-flex w-100 align-center justify-start pr-4" md="9" cols="10">
              <div
                  v-for="(item,i) in headerItems.links"
                  :key="i"
                  class="d-flex justify-center align-center mx-1"
              >
                <div v-if="item.sub_links_count" class="menu">
                  <li @mouseleave="item.expanded = false">

                    <a @mouseover="item.expanded = true" href="#">{{ item.title }}
                      <v-icon dense size="24" color="black">mdi-chevron-down</v-icon>
                    </a>

                    <ul style="margin-top: 16px;" v-if="item.expanded"
                        @click="item.expanded = false">

                      <div class="d-flex">
                        <div>
                          <div v-for="(sub,i) in item.sub_links" :key="i" @mouseover="sub.expanded=true">
                            <div
                                :class="['h-item',
                          currentClass()
                          ]"
                                :style="{'border-bottom':i+1 ===item.sub_links_count? `6px solid ${currentColor()}`:'1px solid #AFAFAF'}"
                                @click="gotoLink(sub.href)"
                            >
                              {{ sub.title }}


                            </div>
                          </div>
                        </div>
                        <div    style="margin-top: 100px;"    v-if="sub.sub!=null&&item.subDomain[2].expanded" v-for="(sub,i) in item.subDomain" :key="i">
                          <div class="d-flex"

                               v-for="(item,j) in sub.sub" :key="item.en"
                          >
                            <div :class="['sub-item',currentClass()]"
                                 :style="{'border-bottom':j+1 ===sub.sub.length? `6px solid ${currentColor()}`:'1px solid #AFAFAF'}"
                                 @click="$router.push('/sub/light-blocks/construction/product/'+item.en)"
                            >

                                {{ item.pr }}
                            </div>
                          </div>
                        </div>
                      </div>

                    </ul>

                  </li>
                </div>
                <div :class="[currentSingleClass()]" style="padding-top: 27px;" v-else @click="gotoLink(item.href)" >
                  <h6 class="font-weight-bold">{{ item.title }}</h6>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <div v-if="$vuetify.breakpoint.mdAndDown">
      <div class="black">
        <div class="mx-2">
          <v-row>
            <v-col class="d-flex align-center" cols="2">
              <v-icon @click="drawer=!drawer" color="white">mdi-menu</v-icon>
            </v-col>
            <v-col :class="[this.$i18n.locale==='pr'?'text-left':'text-right']" cols="10">
              <div class="d-flex justify-end align-center ">
                <form style="display: flex; position: relative" id="demo-2">
                  <input type="search" placeholder="Search">
                  <v-icon style="position: absolute;top: 10px;right: 6px;"
                          class="hover"
                  >mdi-magnify
                  </v-icon>
                </form>
                <v-btn to="/login" small class="mx-2" depressed icon>
                  <p class="ma-0">
                    <v-icon class="hover">mdi-account</v-icon>

                  </p>
                </v-btn>
                <v-menu class="header-color px-2" offset-y open-on-hover>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text
                           x-small
                           min-width="40px"
                           max-width="40px"
                           v-bind="attrs"
                           v-on="on"
                    >
                      <h6 class="white--text pt-1 font-weight-bold">{{ flag[selectedFlag] }}</h6>
                      <!--                      <img width="30" :src="flag[selectedFlag]" :alt="flag[selectedFlag]">-->
                    </v-btn>
                  </template>
                  <div class="header-color d-flex flex-column"
                  >
                    <div
                        v-if="i!==selectedFlag"
                        :style="{'border-bottom':i ===item.length? '4px solid #25458c':'1px solid #AFAFAF'}"
                        @click="changeLanguage(i)" class="menu-item d-flex justify-center align-center black--text"
                        v-for="(item,i) in flag" :key="i"
                    >
                      {{ item }}
                      <!--                      <img width="30" :src="item" :alt="i">-->
                    </div>
                  </div>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
      <v-navigation-drawer
          dark
          color="#2d2d2d"
          style="min-height: 900px;z-index: 99999!important;"
          v-model="drawer"
          absolute
          temporary

          width="fit-content"
      >
        <div class="ma-auto text-center mt-4">
          <div style="position:absolute; top: 16px;right: 16px">
            <v-icon @click="drawer=!drawer">mdi-close</v-icon>
          </div>
          <div class="ma-3 mt-13 text-right">
            <router-link to="/">
              <!--              <img v-if="$route.path.indexOf('light-blocks')>0" height="64" src="@/assets/bloc_logo.svg" alt="icon">-->

              <img @click="$router.push('/')" v-if="this.$i18n.locale==='en'" width="280" src="@/assets/eng_logo.png" alt="icon">
              <img @click="$router.push('/')" v-else width="280" src="@/assets/pr_logo.png" alt="icon">
            </router-link>
            <div
                class="ml-0 mt-5"
            >
              <ul class="mr-7">
                <li class="py-3" v-for="(item,i) in headerItems.links" :key="i">
                  <router-link v-if="item.type==='single'"
                               class="d-block pa-1 text-decoration-none warning--text drawer-item"
                               :to="item.href">
                    <v-icon color="warning ">{{ item.icon }}</v-icon>
                    {{ item.title }}
                  </router-link>
                  <div v-else>
                   <span @click="openList=i" class="warning--text">

                   <v-icon color="warning">{{ item.icon }}</v-icon>
  {{ item.title }}
                    <v-icon color="warning">mdi-chevron-down</v-icon>
                 </span>
                    <div class="open-list-animation" v-if="openList===i">
                      <ul>
                        <li class=" mr-6 py-2 warning--text " v-for="(sub,i) in item.sub_links" :key="i">
                          <router-link class="text-decoration-none warning--text" :to="sub.href">
                            <span style="font-size: 12px" class="warning--text">{{ sub.title }}</span>
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>


            </div>
          </div>

        </div>


      </v-navigation-drawer>
    </div>
  </div>
</template>

<script>
import Scripts from './script';

export default Scripts;
</script>
<style scoped>

.menu {
  font-size: 14px;
  font-weight: bold;
  list-style: none;
}

.menu:hover {
  background: white;
}

.menu a {
  display: inline-flex;
  padding: 30px 20px;
  font-size: 15px;
  font-weight: bold;
  color: black;
  text-decoration: none;
}

ul .menu-item {
  min-width: 240px;
}

.menu li {
  display: block;
  float: right !important;
  position: relative;
  color: black;
}

.menu li ul {
  position: absolute;
  right: 0;
  top: 61px;
  margin: 0;
  padding: 0;
}

.menu li ul li {
  background: white;
  transition: background .2s;
}

.menu li ul li:hover {
  background: #444;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}

.fade-enter, .fade-leave-active {
  opacity: 0;
}

.hover {
  color: #FFFFFF !important;
}

.hover:hover {
  color: #7BAD34 !important;

}

.hover2 {
  color: white !important;
}

.hover2:hover {
  color: #7BAD34 !important;

}

.fixed-logo {
  position: fixed;
  top: 0px;
  right: 32px;
  z-index: 2;
  width: 320px;
  height: 80px;
  padding-top: 8px;
  transition: all 4s ease-in;
}

.open-list-animation {
  animation: listDecoration 10s ease-in;
}


@keyframes open-list {
  0% {
    height: 0px;
  }
  100% {
    height: 100px;
  }
}


@keyframes listDecoration {
  from {
    height: 0
  }
  to {
    height: 100%
  }
}

.top-header {
  padding: 0 43px;
  height: 80px;
  background-color: #7BAD34;
}

li {
  cursor: pointer;
}

span {
  cursor: pointer;
  font-size: 16px;
}

span:hover {
  color: white !important;
}

span:hover > i {
  color: white !important;
}


.text-field {
  border-radius: 0 !important;
  border: 1px solid #AFAFAF !important;
}

.menu-box {
  position: absolute;
  z-index: 9999;
  padding: 14px 36px;
  background: white;
  min-height: 388px;
  width: 100%;
}

.header-position {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 2;
}


.header-position {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 2;
}

h6 {
  color: black;
}

.header-color {
  background: white;
  transition: background-color 300ms ease-in;
  color: black;
}

.header-hover-color {
  transition: background-color 300ms ease-in;
  background: rgb(224, 224, 224);
}

.h-item {
  display: flex;
  align-items: center;
  text-align: right;
  padding: 0 22px;
  /*min-width: max-content;*/
  background: white;
  height: 50px;
  min-width: 220px;
  font-size: 13px;
  font-weight: bold !important;
  color: black;
  cursor: pointer;
}

.sub-item {
  display: flex;
  align-items: center;
  text-align: right;
  padding: 0 22px;
  /*min-width: max-content;*/
  background: white;
  height: 50px;
  min-width: 220px;
  font-size: 13px;
  font-weight: bold !important;
  color: black;
  cursor: pointer;
}


.block-item:hover {
  background: #7BAD34 !important;
  color: #FFFFFF !important;
}

.glass-item:hover {
  background: #0846be !important;
  color: #FFFFFF !important;
}

.product-link {
  color: black;
  padding: 16px;
  height: 80px !important;
  text-decoration: none;
  margin: 0;
}

.product-link:hover {
  background: #FF3A46;
  padding: 16px 16px 12px !important;
  border-bottom: 4px solid #7BAD34;
  /*transition: all .6s;*/
}

.single-glass-item {
  color: black;
  padding: 0 15px;
  height: 80px !important;
  text-decoration: none !important;
  margin: 0;
}

.single-glass-item:hover {
  background: white;
  height: 80px;
  border-bottom: 4px solid #0846be;
  /*transition: all .6s;*/
}

.single-block-item {
  color: black;
  padding: 0 15px;
  height: 80px !important;
  text-decoration: none !important;
  margin: 0;
}

.single-block-item:hover {
  background: white;
  height: 80px;
  border-bottom: 4px solid #7BAD34;
  /*transition: all .6s;*/
}


input {
  outline: none;
}

input[type=search] {
  -webkit-appearance: textfield;
  -webkit-box-sizing: content-box;
  font-family: inherit;
  font-size: 100%;
}

input::-webkit-search-decoration,
input::-webkit-search-cancel-button {
  display: none;
}


input[type=search] {
  z-index: 99999;
  color: #7BAD32;

  padding: 9px 10px 9px 32px;
  width: 55px;

  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;

  -webkit-transition: all .5s;
  -moz-transition: all .5s;
  transition: all .5s;
}

input[type=search]:focus {
  width: 200px;

  border-color: #7BAD34;

  -webkit-box-shadow: 0 0 5px rgba(109, 207, 246, .5);
  -moz-box-shadow: 0 0 5px rgba(109, 207, 246, .5);
  box-shadow: 0 0 5px rgba(109, 207, 246, .5);
}

input:-moz-placeholder {
  color: #7BAD34;
}

input::-webkit-input-placeholder {
  color: #7BAD34;
}

/* Demo 2 */
#demo-2 input[type=search] {
  width: 15px;
  padding-left: 10px;
  color: transparent;
  cursor: pointer;
}


#demo-2 input[type=search]:hover + .hover {
  color: #7BAD32 !important;
}

#demo-2 input[type=search]:hover + .hover2 {
  color: #7BAD34 !important;
}

#demo-2 input[type=search]:focus {
  /*border: 4px solid rgb(37, 69, 140);*/
  width: 200px;
  height: 10px !important;
  margin-top: 8px;
  margin-bottom: 8px;
  padding-left: 32px;
  color: #000;
  background-color: #fff;
  margin-right: 9px;
  padding-right: 9px;
  cursor: auto;
}

#demo-2 input:-moz-placeholder {
  color: transparent;
}

#demo-2 input::-webkit-input-placeholder {
  color: transparent;
}

form > i:hover {
  color: #7BAD34 !important;
}

.block-lang-border {
  border-bottom: 4px solid #7BAD34;
}

.glass-lang-border {
  border-bottom: 4px solid #0846be;
}
.flex-direction-row-reverse{
  flex-direction: row-reverse;
}
</style>